import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from './AuthContext';

const EnterpriseConfigContext = createContext();

export const useEnterprise = () => useContext(EnterpriseConfigContext);

export const EnterpriseConfigProvider = ({ children }) => {
  const { userProfile } = useAuth() || {};
  const [tenantConfig, setTenantConfig] = useState(null);

  useEffect(() => {
    const fetchTenant = async () => {
      if (userProfile?.enterpriseTenantId && userProfile.enterpriseTenantId !== 'public') {
        try {
            const tenantSnap = await getDoc(doc(db, 'enterprises', userProfile.enterpriseTenantId));
            if (tenantSnap.exists()) {
                setTenantConfig(tenantSnap.data());
            }
        } catch (e) {
            console.error("Failed to load tenant config:", e);
        }
      } else {
        setTenantConfig(null); 
      }
    };
    fetchTenant();
  }, [userProfile?.enterpriseTenantId]);

  // STRATEGIC PIVOT: B2C Tiers eradicated. 
  // If the user has an active session, they have clearance to generate telemetry.
  const hasAccess = useCallback((moduleId) => {
    return true; 
  }, []);

  return (
    <EnterpriseConfigContext.Provider value={{
      tenantConfig, hasAccess
    }}>
      {children}
    </EnterpriseConfigContext.Provider>
  );
};